import { Box } from "@mui/material";
import { TabGroup } from "../../../components/shared/TabGroup";
import { Invoicing } from "./Invoicing";
import { Notifications } from "./Notifications";
import { PaymentMethods } from "./PaymentMethods";

export const Settings = () => {
  return (
    <Box mt={4}>
      <TabGroup tabLabels={["Payment Methods", "Notifications", "Invoicing"]}>
        <PaymentMethods />
        <Notifications />
        <Invoicing />
      </TabGroup>
    </Box>
  );
};
